define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/FormData",
	"csi/action/Controller",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"./StyleAttributeMapping/StylePushTemplatesForm"
], function(declare,lang,FormData,Controller,ActionControllerMixin,xml) {

	return declare([Controller, ActionControllerMixin], {
		FIELD_MERCH_PRODUCT_SUBTYPE: "MerchProductSubtype",
		FIELD_TEMPLATE: "Template",
		nodeURL: null,
		templateSelection: null,
		hasStyle: false,
		continueAnyways: false,

		getFormData: function() {
			var	data = this.inherited(arguments);
			return data;
		},

		disableNext: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*Number*/index) {
			return (index == 1) && !this.hasStyle;
		},

		disableFinish: function(/*csi.wizard.Widget*/wizard, /*Content*/page, /*Number*/index) {
			return (index == 0) || ((index == 1) && this.hasStyle);
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {

			var nPage = wizard.getIndexOfPage(nextPage);
			var	fd = this.m_formData;

			if (nPage == 0) {
				fd.m_bRequireOne = true;
				fd.m_bSelectOne = false;
			} else if (nPage == 1){
				var firstPageSelections = wizard.getFormDataFromPage(currentPage).getSelectedNodes();
				for (var i = 0; i < firstPageSelections.length; i++) {
					if (firstPageSelections[i].Style != "centric:") {
						this.hasStyle = true;
					}
				}
				if (wizard.getFormDataFromPage(nextPage) === null) {
					fd = new FormData(this);
					fd.m_bRequireOne = true;
					fd.m_bSelectOne = true;
				} else {
					fd = wizard.getFormDataFromPage(nextPage);
				}
			} else if (nPage == 2) {
				this.nodeURL = xml.nodeGetURL(wizard.getFormDataFromPage(currentPage).getSelectedNode());
			} else {
				this.templateSelection = fd.getFieldValue(this.FIELD_TEMPLATE);
			}

			return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, false) : wizard.carryOverFormData(currentPage, nextPage);
		},

		onPrevPage: function(/*csi.wizard.Widget*/wizard, /*Content*/currentPage, /*Content*/prevPage) {
			var previousPageIndex = wizard.getIndexOfPage(prevPage);
			if (previousPageIndex == 0) {
				this.hasStyle = false;
			}

			return null;
		},

		_onPublishError: function(/*Error*/err) {
            if (err.csiErrorCode.indexOf("CANNOT_MOVE") >= 0) {
                this._promptForMove(err.message);
            } else {
                this.inherited(arguments);
            }
        },

        _promptForMove: function(/*String*/errorMessage) {
            this.confirmAction({
                message: errorMessage,
                onResponse: lang.hitch(this, this._afterPromptForMove)
            });
        },

        _afterPromptForMove: function(/*String*/key) {
            if (key == "Y") {
                this.continueAnyways = true;
                this.setProgress();
                Controller.prototype.process.call(this);
            } else {
                this.postProcess();
            }
        },

		toWriterRequest: function(/*FormData?*/fd) {
			// summary: handle request for second and third page
			var	call = this.inherited(arguments);
			call.addParameter("MerchCollectionSelectionURL", xml.ATTR_REF, this.nodeURL);
			call.addParameter("Template", xml.ATTR_REF, this.templateSelection);
			call.addParameter("Continue", xml.ATTR_BOOLEAN, this.continueAnyways);

			return call;
		}
	});
});